// extracted by mini-css-extract-plugin
export default {"wrapper":"Sy-z","button":"Ty-z","alternate":"Uy-z","disabled":"Vy-z","paymentWarning":"Wy-z","fadeIn":"Xy-z"};